import { jsx as _jsx } from "react/jsx-runtime";
import { COUNTRY_CODES } from '@kanos/domain';
import { SearchSelectField } from '@kanos/ui';
const names = new Intl.DisplayNames(['de'], { type: 'region', fallback: 'code' });
/** The countries most chosen, at the head of the list; the rest by name. */
const FIRST = ['DE', 'AT', 'CH'];
/** A country's German name, e.g. `DE` → „Deutschland“; the code itself where none is known. */
export const countryName = (code) => names.of(code) ?? code;
const optionOf = (code) => ({
    id: code,
    label: countryName(code),
    // „DE“ finds Germany as well as „Deutsch“ does.
    keywords: [code],
});
const COUNTRIES = [
    ...FIRST.map(optionOf),
    ...COUNTRY_CODES.filter((c) => !FIRST.includes(c))
        .map(optionOf)
        .sort((a, b) => a.label.localeCompare(b.label, 'de')),
];
/** The entry of an optional field that leaves the country unstated. */
const NONE = 'none';
/**
 * A country, chosen by its German name and kept as its two-letter code (ISO 3166-1), as the API
 * keeps it. Typing narrows the list - by name or code. Optional, it offers „Nicht angegeben“;
 * `extra` adds codes beyond the countries, e.g. `EU` for an institution of the Union.
 */
export function CountryField({ label, value, onChange, isRequired = false, isReadOnly = false, extra = [], }) {
    const options = [
        ...(isRequired ? [] : [{ id: NONE, label: 'Nicht angegeben' }]),
        ...extra.map(optionOf),
        ...COUNTRIES,
    ];
    return (_jsx(SearchSelectField, { label: label, placeholder: "z. B. Deutschland", options: options, value: value === '' ? (isRequired ? null : NONE) : value, onChange: (next) => onChange(next === NONE ? '' : next), isRequired: isRequired, isDisabled: isReadOnly }));
}
//# sourceMappingURL=country-field.js.map